/* S1 Trusted Band: fade-ins + click-to-play video (src loads on first tap,
   matching the SPA's manual play/pause with the play chrome hidden while
   playing). */

class S1TrustedBand extends HTMLElement {
  connectedCallback() {
    if (!this._fadeIo) {
      this._fadeIo = new IntersectionObserver((entries) => {
        entries.forEach((en) => {
          if (en.isIntersecting) {
            en.target.classList.add('is-visible');
            this._fadeIo.unobserve(en.target);
          }
        });
      }, { threshold: 0.2 });
    }
    this.querySelectorAll('.s1-tb-fade:not(.is-visible)').forEach((el) => this._fadeIo.observe(el));

    /* re-connects (theme editor drags) must not stack listeners */
    if (this._bound) return;
    this._bound = true;

    const wrap = this.querySelector('[data-tb-video-wrap]');
    const video = this.querySelector('[data-tb-video]');
    if (!wrap || !video) return;
    const toggle = () => {
      if (!video.src && video.dataset.src) video.src = video.dataset.src;
      if (video.paused) video.play().catch(() => {});
      else video.pause();
    };
    wrap.addEventListener('click', toggle);
    wrap.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        toggle();
      }
    });
    video.addEventListener('play', () => {
      wrap.classList.add('is-playing');
      wrap.setAttribute('aria-label', 'Pause video');
    });
    video.addEventListener('pause', () => {
      wrap.classList.remove('is-playing');
      wrap.setAttribute('aria-label', 'Play video');
    });
  }

  disconnectedCallback() {
    if (this._fadeIo) this._fadeIo.disconnect();
  }
}

if (!customElements.get('s1-trusted-band')) {
  customElements.define('s1-trusted-band', S1TrustedBand);
}
